export const getUtmsFromQuery = (query: Record<string, any>) => {
  const utms = Object.entries(query).filter(([key]) => {
    return key.includes('utm');
  }).reduce<Record<string, any>>((obj, utm) => {
    obj[utm[0]] = utm[1];
    return obj;
  }, {});
  return utms;
}
